import { ReactNode } from "react";

export const SocialMediaIcon = ({ url, icon }: { url: string; icon: ReactNode }) => (
    <a href={url} style={{ color: "inherit", textDecoration: "none !important" }}>
      {icon}
    </a>
  )